import { render, staticRenderFns } from "./KBButtonLoader.vue?vue&type=template&id=845895fe&scoped=true&"
var script = {}
import style0 from "./KBButtonLoader.vue?vue&type=style&index=0&id=845895fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845895fe",
  null
  
)

export default component.exports